import React, { useState } from 'react';
import { toast } from './Toast';
import api from '../services/api';

const RecurringWarningModal = ({ status, onGenerate, onDismiss }) => {
  const [generating, setGenerating] = useState(false);
  if (!status.shouldShowWarning) return null;

  const nextMonthName = new Date(status.nextMonth + 'T12:00:00').toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

  const handleGenerate = async () => {
    setGenerating(true);
    try {
      const localDate = new Date().toLocaleDateString('en-CA');
      const response = await api.post('/recurring/generate-month', { localDate });
      toast.success('✅ Generated ' + response.data.totalCreated + ' service orders for ' + nextMonthName);
      onGenerate(); // close modal + refresh
    } catch (err) {
      toast.error('Error: ' + (err.response?.data?.message || err.message));
    } finally {
      setGenerating(false);
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.warningHeader}>
          <span style={styles.warningIcon}>⚠️</span>
          <h2 style={styles.title}>Reminder: Generate Recurring Services</h2>
        </div>
        
        <div style={styles.content}>
          <p style={styles.message}>
            You need to generate recurring service orders for <strong>{nextMonthName}</strong> before the end of this month.
          </p>
          
          <div style={styles.stats}>
            <div style={styles.statItem}>
              <span style={styles.statLabel}>Days Remaining:</span>
              <span style={styles.statValue}>{status.daysUntilEndOfMonth}</span>
            </div>
            <div style={styles.statItem}>
              <span style={styles.statLabel}>Active Recurrences:</span>
              <span style={styles.statValue}>{status.activeRecurrences}</span>
            </div>
          </div>
        </div>

        <div style={styles.actions}>
          <button onClick={onDismiss} style={styles.dismissBtn}>
            Remind Me Later
          </button>
          <button onClick={handleGenerate} disabled={generating} style={styles.generateBtn}>
            {generating ? 'Generating...' : 'Generate ' + nextMonthName + ' Now'}
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2000
  },
  modal: {
    backgroundColor: 'white',
    borderRadius: '12px',
    width: '90%',
    maxWidth: '500px',
    boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
    overflow: 'hidden'
  },
  warningHeader: {
    backgroundColor: '#FF9800',
    color: 'white',
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '15px'
  },
  warningIcon: {
    fontSize: '32px'
  },
  title: {
    fontSize: '20px',
    margin: 0
  },
  content: {
    padding: '30px'
  },
  message: {
    fontSize: '16px',
    color: '#333',
    marginBottom: '20px',
    lineHeight: '1.5'
  },
  stats: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '15px',
    marginTop: '20px'
  },
  statItem: {
    backgroundColor: '#FFF3E0',
    padding: '15px',
    borderRadius: '8px',
    textAlign: 'center'
  },
  statLabel: {
    display: 'block',
    fontSize: '13px',
    color: '#666',
    marginBottom: '5px'
  },
  statValue: {
    display: 'block',
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#FF9800'
  },
  actions: {
    display: 'flex',
    gap: '10px',
    padding: '20px',
    borderTop: '1px solid #f0f0f0'
  },
  dismissBtn: {
    flex: 1,
    padding: '12px',
    backgroundColor: '#f5f5f5',
    border: '1px solid #ddd',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600'
  },
  generateBtn: {
    flex: 2,
    padding: '12px',
    backgroundColor: '#FF9800',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600'
  }
};

export default RecurringWarningModal;
